import { ErrorOutline } from '@mui/icons-material';
import {
    Box,
    Card,
    CardContent,
    Typography,
} from '@mui/material';

const colors = new Map([
    ['warning', 'orange'],
    ['danger', 'red'],
]);

function NotificationCard({ title, text, variant, sx }) {
    return (
        <Card sx={sx}>
            <CardContent>
                <Box sx={{ display: 'flex', fontWeight: 'bold', color: colors.get(variant), gap: 1}}>
                    <ErrorOutline />
                    <Typography >{title}</Typography>
                </Box>
                <Typography sx={{mt: 2}}>
                    {text}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default NotificationCard
